import {observer} from "mobx-react";
import {useCallback, useEffect, useMemo, useState} from "react";
import {useStore} from "../../../../../../../hooks";
import FilterSelector from "../../../../../../../elements/v2/FilterSelector/FilterSelector";
import {SearchInput} from "../SearchInput";
import {RoundedButton} from "../../../../../../../elements";

export const Filters = observer(({ users }) => {
  const { marketingStore } = useStore();
  const { filters } = marketingStore;
  
  
  const filteredUsers = useMemo(() => {
    return users.map((user) => `${user.first_name} ${user.last_name}`);
  }, [users]);

  const filterSelectorsConfig = useMemo(() => [
    {
      title: "Type",
      data: [
        "Marketing",
        "Trigger",
      ],
      minWidthForm: 92,
      minWidthPaper: 224,
      value: filters.type,
      filterType: 'type'
    },
    {
      title: "Owner",
      data: filteredUsers,
      minWidthForm: 103,
      minWidthPaper: 263,
      value: filters.ownerNames,
      filterType: 'owner'
    },
    {
      title: "Status",
      data: [
        "Draft",
        "Canceled",
        "Scheduled",
        "Running",
        "Finished",
        "Archived"
      ],
      minWidthForm: 102,
      minWidthPaper: 250,
      value: filters.status,
      filterType: 'status'
    },
  ], [filters.type,  filters.owner, filters.status, filteredUsers]);

  const handleFilterChange = useCallback((filterType) => (event) => {
    const newValue = typeof event.target.value === "string"
      ? event.target.value.toLowerCase().split(",")
      : event.target.value.map((val) => val.toLowerCase());

    switch (filterType) {
      case "type":
        marketingStore.setFilter({ type: newValue });
        break;
      case "owner":{
        const mappedValues = newValue.map((name) => {
          const user = users.find(
            (user) => `${user.first_name.toLowerCase()} ${user.last_name.toLowerCase()}` === name
          );
          return user ? user.id : null;
        }).filter((id) => id !== null);
        
        marketingStore.setFilter({ ownerIds: mappedValues, ownerNames: newValue });
        break; 
      }
      case "status":
        marketingStore.setFilter({ status: newValue });
        break;
    } 
  }, [users]);

  const handleClearAll = useCallback(() => {
    marketingStore.setFilter({
      type: [],
      ownerName: [],
      ownerIds: [],
      status: [],
      search: "",
    });
  }, []);
  
  return (
    <>
      <SearchInput value={filters.search} onChange={(value) => marketingStore.setFilter({ search: value })} />
      {filterSelectorsConfig.map((config) => (
        <FilterSelector
          itemHeight={40} 
          itemPaddingTop={8}
          key={config.title}
          {...config}
          handleChange={handleFilterChange(config.filterType)}
        />
      ))}
      <RoundedButton
        width="86px"
        height="40px"
        kind="confirm"
        outline={true}
        fontWeight="normal"
        fontSize="14px"
        margin="0"
        borderRadius="8px"
        onClick={handleClearAll}
      >
        Clear all
      </RoundedButton>
    </>
  );
});
